import { CMS_Content_Module_LiveStreamData } from './types';
import { Livestream } from '@project/site/modules/livestream';

export const LivestreamContentModule: React.FC<CMS_Content_Module_LiveStreamData> = (props) => {
  return <Livestream {...props} />;
};
